import React, { Component } from "react"

import { withFirebase } from "../Firebase"

const INITIAL_STATE = {
  error: null,
}

class LogoutButton extends Component {
  constructor(props) {
    super(props)

    this.state = { ...INITIAL_STATE }
  }

  onClick = event => {
    this.props.firebase
      .doSignOut()
      .then(() => {
        this.setState({ ...INITIAL_STATE })
      })
      .catch(error => {
        this.setState({ error })
      })

    event.preventDefault()
  }

  render() {
    // const { error } = this.state

    return (
      <button onClick={this.onClick} className="default-btn mr-3">
        <i className="bx bxs-log-in"></i> Log Out <span></span>
      </button>
    )
  }
}

export default withFirebase(LogoutButton)
